require(
      "!../../../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../../../node_modules/json-loader/index.js!./member-services-member-benefits-love-my-credit-union-rewards.json") })
        }
      }, "path---member-services-member-benefits-love-my-credit-union-rewards");
     }
    


//////////////////
// WEBPACK FOOTER
// /home/circleci/repo/~/gatsby-module-loader?name=path---member-services-member-benefits-love-my-credit-union-rewards!./.cache/json/member-services-member-benefits-love-my-credit-union-rewards.json
// module id = 2600
// module chunks = 231608221292675